import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-select-overlay',
  templateUrl: './select-overlay.component.html',
  styleUrls: ['./select-overlay.component.scss']
})
export class SelectOverlayComponent implements Overlayable{

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
}
